import React, { useCallback, useContext } from 'react';
import classNames from 'classnames';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { Button } from 'ncoded-component-library';
import MymeTypeIcon from 'router/subrouters/DataRoom/components/DataRoomDocumentsRouter/components/MymeTypeIcon';
import DataRoomNodeTagAndVersion from 'components/DataRoomNodeTagAndVersion';
import DocumentViewContext from 'providers/DocumentView/DocumentView.context';
import { getNodeMimeType } from 'utils';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';

import './DataRoomNodePreview.styles.scss';

type DataRoomNodePreviewProps = {
  className?: string;
  node: DataRoomNode;
  dataRoomName: string;
  ownerId: string;
  userSide: QAndASides;
};

const DataRoomNodePreview: React.FC<DataRoomNodePreviewProps> = (props) => {
  const { className, node, dataRoomName, userSide, ownerId } = props;

  const { _id, name, tag, version } = node || {};

  const disabled = !_id;

  const classes = classNames('data-room-node-preview', className);

  const { openNode } = useContext(DocumentViewContext);

  const handleOpen = useCallback(() => {
    if (disabled) return;

    openNode(node, { dataRoomName, userSide, ownerId });
  }, [disabled, node, dataRoomName, userSide, ownerId, openNode]);

  return (
    <Button className={classes} disabled={disabled} onClick={handleOpen}>
      <MymeTypeIcon mimeType={getNodeMimeType(node)} />
      <span>
        <span>{name}</span>
        <DataRoomNodeTagAndVersion tag={tag} version={version} />
      </span>
    </Button>
  );
};

export default DataRoomNodePreview;
